import { shiftEditorViewState } from "..";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateTagsShift", function updateTagsShift(tagIds: string[]) {
    if (shiftEditorViewState().shift) {
        shiftEditorViewState().shift.tagIds = tagIds;
    }
});